module.exports = __webpack_public_path__ + "static/5-177d8847b63d204fd2d1bd377db91055.jpg";